import { pickDefaultPlantId } from '../Planning/workScheduleDefaults';

export { pickDefaultPlantId };

export function getInitialDesignMixFormState() {
  return {
    cem1: 0,
    cem2: 0,
    cem3: 0,
    cem4: 0,
    cem5: 0,
    agg1: 0,
    agg2: 0,
    agg3: 0,
    agg4: 0,
    agg5: 0,
    water1: 0,
    water2: 0,
    adm1: 0,
    adm2: 0,
    others: 0,
    plant_id: '',
    work_schedule_id: '',
    recipe_code: '',
    total_cem: 0,
    water_cem: 0,
    density: 0,
  };
}

export function buildWorkScheduleOptionLabel(workSchedule) {
  const salesOrder = workSchedule?.sales_order_detail?.sales_order;
  const product = workSchedule?.sales_order_detail?.product;
  return `${workSchedule.schedule_no}-${salesOrder?.prefix || ''}${salesOrder?.order_no || ''}(${product?.name || ''})`;
}

export function buildWorkScheduleDisplayLabel(workSchedule) {
  if (!workSchedule?.schedule_no) {
    return '';
  }
  return buildWorkScheduleOptionLabel(workSchedule);
}

export function mapAllowedPlants(plantList) {
  return (plantList?.plant_list || [])
    .filter((plant) => plant.status)
    .map((plant) => ({
      value: plant.id,
      label: plant.plant_alias,
    }));
}
